<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import AdminAppPaidShowAdd2026 from "~/src/components/AdminAppPaidShowAdd2026.vue";

export default {
  components: {
    AdminAppPaidShowAdd2026,
  },

  data: () => ({
    loaded: false,
    loading: false,
    canCreate: false,
  }),

  computed: {
    ...mapGetters("admin-contracts2026", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,

    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,
    isSupperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
  },

  created() {
    this.init();
  },

  async mounted() {
    // Whole page (incl. teleported menus/date pickers) wears the brand font; see App.vue.
    document.body.classList.add("font-made-page");
    this.canCreate = await this.hasRole("YANGI_QOSHISH", "CREATE");
  },

  beforeDestroy() {
    document.body.classList.remove("font-made-page");
  },

  methods: {
    ...mapActions("admin-contracts2026", ["INIT_BY_ID"]),
    ...mapActions("admin-contract2026", ["INIT_APPLICATION"]),

    async init() {
      this.loading = true;
      const data = await this.$axios.$post("/admin/contract2026/add/student");
      this.loading = false;
      const id = data ? data : null;
      this.INIT_BY_ID({ id }).then((status) => {
        if (!status) {
          this.$router.replace("/dashboard");
          return;
        }
      });
    },

    onAdd() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.loaded = true;
      });
    },

    async hasRole(panel, op) {
      try {
        const res = await axios.get(`/admin/panel-permissions/check`, {
          params: { appPanel: panel, op }
        });
        return res.data === true;
      } catch {
        return false;
      }
    },
  },
};
</script>

<template>
  <div class="ans-page">
    <v-container fluid class="ans-container">
      <!-- Header -->
      <div class="ans-header">
        <v-btn
          @click="$router.push('/contract_2026_2027')"
          elevation="0"
          rounded
          large
          class="modern-back-btn px-6 py-3 d-flex align-center"
          style="
            border: 1px solid #e0e0e0;
            background: linear-gradient(135deg, #ffffff, #f9f9f9);
            box-shadow: none;
            transition: all 0.25s ease;
          "
        >
          <v-icon
            left
            size="22"
            style="color:#0c0c0c; transition: transform 0.2s;"
            class="back-icon"
          >
            mdi-arrow-left
          </v-icon>
          <span
            class="font-weight-bold text-uppercase"
            style="letter-spacing:1px; font-size:14px; color:#0c0c0c;"
          >
            Orqaga
          </span>
        </v-btn>

      </div>

      <!-- Loading -->
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="#00274d"
        class="ans-progress"
      />

      <!-- Empty state -->
      <div v-if="!loaded" class="ans-empty">
        <div class="ans-empty__card">
          <div class="ans-empty__icon">
            <v-icon size="52" color="#00274d">mdi-account-plus-outline</v-icon>
          </div>
          <h2 class="ans-empty__title">{{ $t("add_new_student") }}</h2>
          <p class="ans-empty__desc">Kontrakt 2026-2027</p>
          <p class="ans-empty__hint">
            Yangi talabani qo'shish uchun
            <strong>"{{ $t("Add") }}"</strong> tugmasini bosing
          </p>
          <v-btn
            v-if="isSupperAdmin && canCreate"
            :loading="loading"
            class="ans-add-btn ans-add-btn--lg mt-5"
            depressed
            @click="onAdd"
          >
            <v-icon left size="18">mdi-plus</v-icon>
            {{ $t("Add") }}
          </v-btn>
        </div>
      </div>

      <!-- Form -->
      <div v-else class="ans-form-card">
        <admin-app-paid-show-add2026 />
      </div>
    </v-container>
  </div>
</template>

<style lang="scss">
$navy: #00274d;
$radius: 14px;
$line: #e6e8ec;

.ans-page {
  min-height: 100vh;
}
.ans-container {
  max-width: 1200px !important;
  padding: 24px 32px !important;
}

/* ── Header ── */
.ans-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

/* ── Back button (ORQAGA) ── */
.ans-page .modern-back-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
}
.ans-page .modern-back-btn:active {
  transform: translateY(0);
  box-shadow: none !important;
}
.ans-page .back-icon:hover {
  transform: translateX(-3px);
}

/* ── Add button (yellow) ── */
.ans-page .ans-add-btn.v-btn,
.ans-page .ans-add-btn.v-btn.theme--dark,
.ans-page .ans-add-btn.v-btn.theme--light {
  background-color: #ffd451 !important;
  color: #111318 !important;
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  padding: 0 24px !important;
  height: 42px !important;
  font-size: 14px !important;
  box-shadow: none !important;
  transition: all 0.18s ease;
}
.ans-page .ans-add-btn.v-btn .v-btn__content,
.ans-page .ans-add-btn.v-btn .v-icon {
  color: #111318 !important;
}
.ans-page .ans-add-btn.v-btn:hover {
  box-shadow: 0 4px 12px rgba(255,212,81,.4) !important;
  transform: translateY(-1px);
}
.ans-page .ans-add-btn--lg.v-btn {
  height: 48px !important;
  padding: 0 32px !important;
  font-size: 15px !important;
}

/* ── Progress ── */
.ans-progress {
  border-radius: 4px;
  margin-bottom: 16px;
}

/* ── Empty state ── */
.ans-empty {
  display: flex;
  justify-content: center;
  padding: 48px 16px 80px;
}
.ans-empty__card {
  text-align: center;
  background: #fff;
  border: 1px solid $line;
  border-radius: $radius;
  padding: 48px 40px;
  max-width: 460px;
  width: 100%;
}
.ans-empty__icon {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: rgba(0, 39, 77, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}
.ans-empty__title {
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 4px;
}
.ans-empty__desc {
  font-size: 14px;
  font-weight: 600;
  color: $navy;
  margin: 0 0 8px;
}
.ans-empty__hint {
  font-size: 13px;
  color: #667085;
  line-height: 1.6;
  margin: 0;
}

/* ── Form card ── */
.ans-form-card {
  background: #fff;
  border: 1px solid $line;
  border-radius: $radius;
  padding: 32px;
}

/* ── Dark Mode ── */
.theme--dark {
  .modern-back-btn {
    background: linear-gradient(135deg, #1a1b23, #22232e) !important;
    border-color: #2a2c3a !important;
  }
  .modern-back-btn .back-icon,
  .modern-back-btn span {
    color: #d5d6de !important;
  }
  .ans-empty__card {
    background: #1a1b23;
    border-color: #2a2c3a;
  }
  .ans-empty__icon {
    background: rgba(255,255,255,.05);
  }
  .ans-empty__title {
    color: #e4e5eb;
  }
  .ans-empty__desc {
    color: #7da5c9;
  }
  .ans-empty__hint {
    color: #8b8d9e;
  }
  .ans-form-card {
    background: #1a1b23;
    border-color: #2a2c3a;
  }
  .ans-add-btn.v-btn,
  .ans-add-btn.v-btn.theme--dark {
    background-color: #ffd451 !important;
    color: #111318 !important;
  }
  .ans-add-btn.v-btn .v-btn__content,
  .ans-add-btn.v-btn .v-icon {
    color: #111318 !important;
  }
}
@media (max-width: 600px) {
  .ans-container { padding: 16px 12px !important; }
  .ans-form-card { padding: 16px; }
}
</style>
